import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

const tasPaymentsUrl = (path?: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'tas-payments' },
    op: 'query',
    resourcePath: 'tas-payments',
  };
  const base = buildBaseURL(opts);
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base;
};

/** POST /tas-payments/create_payment — admin only. */
export function createTasPaymentRequest(companyId: string): RequestInfo {
  return {
    url: tasPaymentsUrl('create_payment'),
    method: 'POST',
    body: JSON.stringify({ company_id: companyId }),
    cacheOptions: { [SkipCache]: true },
  };
}

/** POST /tas-payments/make_payment — admin only. Create + settle. */
export function createAndSettleTasPaymentRequest(companyId: string): RequestInfo {
  return {
    url: tasPaymentsUrl('make_payment'),
    method: 'POST',
    body: JSON.stringify({ company_id: companyId }),
    cacheOptions: { [SkipCache]: true },
  };
}

/** PUT /tas-payments/:id/settle_payment — admin + employee admin views. */
export function settleTasPaymentRequest(paymentId: string): RequestInfo {
  return {
    url: tasPaymentsUrl(`${paymentId}/settle_payment`),
    method: 'PUT',
    cacheOptions: { [SkipCache]: true },
  };
}

/** DELETE /tas-payments/:id/cancel_payment — admin + employee admin views. */
export function cancelTasPaymentRequest(paymentId: string): RequestInfo {
  return {
    url: tasPaymentsUrl(`${paymentId}/cancel_payment`),
    method: 'DELETE',
    cacheOptions: { [SkipCache]: true },
  };
}
